export type ToTitleCaseOptions = {
    ignoreAllCaps?: boolean;
};

export function toTitleCase(str: string, options: ToTitleCaseOptions = {}) {
    if (!str) return '';

    if (options.ignoreAllCaps && str === str.toUpperCase()) {
        return str;
    }

    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
